import {
    ITimerCommand,
    TimerWorkerCommand,
    SetIntervalCommand,
    SetTimeoutCommand,
    ClearIntervalCommand,
    ClearTimeoutCommand,
    TimerResponse,
    TimerErrorResponse
} from "flow/workers/TimerWorkerCommand";

type ActualTimerIds = {
    [timerId: number]: number;
};

const ctx: Worker = self as any;

const actualTimerIds: ActualTimerIds = {};

function workerSetInterval(command: SetIntervalCommand) {
    const actualTimerId = self.setInterval(() => {
        ctx.postMessage(new TimerResponse(command.timerId));
    }, command.delay);

    actualTimerIds[command.timerId] = actualTimerId;
}

function workerSetTimeout(command: SetTimeoutCommand) {
    const actualTimerId = self.setTimeout(() => {
        ctx.postMessage(new TimerResponse(command.timerId));
    }, command.delay);

    actualTimerIds[command.timerId] = actualTimerId;
}

function workerClearInterval(command: ClearIntervalCommand) {
    if (command.timerId !== 0 && actualTimerIds[command.timerId]) {
        self.clearInterval(actualTimerIds[command.timerId]);
        delete actualTimerIds[command.timerId];
    }
}

function workerClearTimeout(command: ClearTimeoutCommand) {
    if (command.timerId !== 0 && actualTimerIds[command.timerId]) {
        self.clearTimeout(actualTimerIds[command.timerId]);
        delete actualTimerIds[command.timerId];
    }
}

self.addEventListener("message", (event: MessageEvent) => {
    const command = event.data as ITimerCommand;

    if (command.command === undefined) {
        ctx.postMessage(new TimerErrorResponse("Unknown message", command));
        return;
    }

    switch (command.command) {
        case TimerWorkerCommand.SetInterval:
            workerSetInterval(command as SetIntervalCommand);
            return;
        case TimerWorkerCommand.SetTimeout:
            workerSetTimeout(command as SetTimeoutCommand);
            return;
        case TimerWorkerCommand.ClearInterval:
            workerClearInterval(command as ClearIntervalCommand);
            return;
        case TimerWorkerCommand.ClearTimeout:
            workerClearTimeout(command as ClearTimeoutCommand);
            return;
    }
});
